import React from 'react';
import { Check, X } from 'lucide-react';
interface PasswordRequirementsProps {
  password: string;
  confirmPassword: string;
}

export const PASSWORD_REQUIREMENTS = [
  { key: 'length', label: 'At least 12 characters', test: (pw: string) => pw.length >= 12 },
  { key: 'uppercase', label: 'One uppercase letter', test: (pw: string) => /[A-Z]/.test(pw) },
  { key: 'lowercase', label: 'One lowercase letter', test: (pw: string) => /[a-z]/.test(pw) },
  { key: 'number', label: 'One number', test: (pw: string) => /[0-9]/.test(pw) },
  { key: 'special', label: 'One special character', test: (pw: string) => /[^A-Za-z0-9]/.test(pw) },
] as const;

export const isPasswordValid = (password: string): boolean => {
  return PASSWORD_REQUIREMENTS.every(req => req.test(password));
};

export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  password,
  confirmPassword,
}) => {
  if (!password) return null;

  const allRequirements = PASSWORD_REQUIREMENTS.map(req => ({
    key: req.key,
    label: req.label,
    met: req.test(password),
  }));

  const passwordsMatch = confirmPassword.length > 0 && password === confirmPassword;

  return (
    <div className="mt-3 space-y-1.5">
      {allRequirements.map(req => (
        <div
          key={req.key}
          className={`flex items-center gap-2 text-sm transition-colors duration-300 ease-in-out ${
            req.met
              ? 'text-green-600 dark:text-green-400'
              : 'text-red-400 dark:text-red-400'
          }`}
        >
          {req.met ? (
            <Check className="w-4 h-4 flex-shrink-0 transition-all duration-300 ease-in-out" />
          ) : (
            <X className="w-4 h-4 flex-shrink-0 transition-all duration-300 ease-in-out" />
          )}
          <span className="transition-colors duration-300 ease-in-out">{req.label}</span>
        </div>
      ))}
      <div
        className={`flex items-center gap-2 text-sm transition-colors duration-300 ease-in-out ${
          passwordsMatch
            ? 'text-green-600 dark:text-green-400'
            : 'text-red-400 dark:text-red-400'
        }`}
      >
        {passwordsMatch ? (
          <Check className="w-4 h-4 flex-shrink-0 transition-all duration-300 ease-in-out" />
        ) : (
          <X className="w-4 h-4 flex-shrink-0 transition-all duration-300 ease-in-out" />
        )}
        <span className="transition-colors duration-300 ease-in-out">Passwords match</span>
      </div>
    </div>
  );
};

export default PasswordRequirements;
